<template>
  <div class="container">
    <div class="row">
      <a
        class="d-flex flex-column text-center col-md-2 m-3"
        v-for="release in releases"
        :href="'https://static.japanparts.com.br' + release.launch_image"
        target="_blank"
        :title="release.code"
      >
        <!--<p class="m-0">{{release.part_subcategory_name ? release.part_subcategory_name : '&nbsp;'}}</p>-->
        <img class="m-auto" :src="url + release.launch_image" alt>
        <p class="text-truncate m-0">{{release.code}}</p>
        <!--<p class="m-0 mt-auto">{{release.bar_code ? release.bar_code : '&nbsp;'}}</p>-->
      </a>
    </div>
  </div>
</template>
<script>
export default {
  props: {
    releases: {
      type: Array,
      default: []
    }
  },
  data() {
    return {
      url: "https://static.japanparts.com.br"
    };
  },
  methods: {
    // openPart(code) {
    //   this.$router.push(`/produto/${code}`);
    // }
  }
};
</script>

<style scoped>
a {
  cursor: pointer;
}
a:not([href]):not([tabindex]) {
  color: #ccb025;
}

a:not([href]):not([tabindex]):hover,
a:not([href]):not([tabindex]):focus {
  color: #0056b3;
}
</style>



// WEBPACK FOOTER //
// src/components/ReleaseList.vue